import OtpModel from '@/app-core/api/models/otp/OtpModel'
import API from '@/app-core/api/Api'

export default {
  name: 'AuthOtp',
  data() {
    return {
      otpDialogVisible: false,
      otpModel        : null,
      otpError        : '',
      otpProgress     : {}
    }
  },
  created() {
    this.$bus.$on('otp:time-start', this.onOtpStart)
    this.$bus.$on('otp:time-progress', this.onOtpProgress)
    this.$bus.$on('otp:time-end', this.onOtpEnd)
  },
  beforeDestroy() {
    this.$bus.$off('otp:time-start', this.onOtpStart)
    this.$bus.$off('otp:time-progress', this.onOtpProgress)
    this.$bus.$off('otp:time-end', this.onOtpEnd)
  },
  methods: {
    otpRequest() {
      this.isFormSaving = true
      this.otpError = ''
      if (this.otpModel) this.otpModel.TimerStop(false)
      this.otpModel = new OtpModel({email: this.model.Email, prefix: this.model.PhonePrefix, phone: this.model.Phone})
      this.otpModel.type = this.AppConfig?.Auth?.Otp?.Email ? 'email' : 'sms'
      const response = this.otpModel.Get()
      this.handleOtpRequestResponse(response)
    },
    handleOtpRequestResponse(result) {
      result
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response) && !data?.Messages?.Error) {
            this.handleOtpRequestSuccess(response)
          } else {
            this.handleOtpRequestError(response)
          }
        })
        .catch((error) => {
          this.handleOtpRequestError(error.response)
        })
        .finally(() => {
          this.isFormSaving = false
        })
    },
    handleOtpRequestSuccess(response) {
      const data = API.responseData(response)
      this.otpModel.time = data.time
      this.otpModel.TimerStart()
      this.otpDialogVisible = true
      this.isFormSaving = false
    },
    handleOtpRequestError(response) {

    },

    onOtpStart() {
      this.otpError = ''
    },

    onOtpProgress(data) {
      this.otpProgress = data
    },

    onOtpEnd() {
      this.otpError = ''
    },

    otpValidate() {
      if (this.otpModel && !this.otpModel.validate()) return

      this.isFormSaving = true
      this.otpError = ''
      const response = this.otpModel.Verify()
      this.handleOtpValidateResponse(response)
    },
    handleOtpValidateResponse(result) {
      result
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response) && !data?.Messages?.Error) {
            this.handleOtpValidateSuccess(response)
          } else {
            this.handleOtpValidateError(response)
          }
        })
        .catch((error) => {
          this.handleOtpValidateError(error.response)
        })
        .finally(() => {
          if (this.otpModel) this.otpModel.otp = ''
          this.isFormSaving = false
        })
    },
    handleOtpValidateSuccess(response) {
      if (this.otpModel) {
        this.otpModel.TimerStop(false)
        if (this.otpModel.type === 'sms') this.model.PhoneValidated = true
        if (this.otpModel.type === 'email') this.model.EmailValidated = true
      }

      this.otpDialogVisible = false
      this.isFormSaving = false
      this.saveFromData()
    },
    handleOtpValidateError(response) {
      const data = API.responseData(response)
      this.otpError = data?.Messages?.Error || this.$t('Common.Error.Generic')
    }
  }
}
